import React, { Fragment, useState, useEffect, useRef } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { Controller, useForm } from "react-hook-form";
import CKEditors from "react-ckeditor-component";
import { Plus, Trash } from "react-feather";
import styled from "styled-components";
import SweetAlert from 'sweetalert2';
import axiosConfig from "../../services/axiosConfig";
import setHeader from "../../components/Functions/setHeader";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import Dropzone from 'react-dropzone-uploader';
import { SITE_URL } from "../../services/Const";


const Products = () => {
    const { register, control, handleSubmit, reset, setValue, getValues, formState: { errors } } = useForm({ mode: "onChange" });
    const [content, setContent] = useState('');
    const [content2, setContent2] = useState('');
    const [fname, setFname] = useState('');
    const [featurefile, setFeaturefile] = useState('');
    const [features, setAllfeature] = useState([]);
    const fileInputRef = useRef(null);
    const [categories, setCategory] = useState([]);
    const [groups, setGroup] = useState([]);
    const [brands, setBrand] = useState([]);
    const [materials, setMaterial] = useState([]);
    const [colors, setColor] = useState([]);
    const [sizes, setSize] = useState([]);
    const [images, setImages] = useState([]); // To store selected image data
    const [selectedColors, setSelectedColors] = useState([]);
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [pcodeError, setPcodeError] = useState("");
    const [skuError, setSkuError] = useState("");
    const [editFormData, setEditFormData] = useState({});
    const [loadingAddProduct, setLoadingAddProduct] = useState(false);
    const [loadingEditData, setLoadingEditData] = useState(false);
    const [loadingUpdateProduct, setLoadingUpdateProduct] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();
    const [editMode, setEditMode] = useState(false);
    const [isFormUpdated, setIsFormUpdated] = useState(false);

    useEffect(() => {
        if (id) {
            editData();
        }

        CategoryData();
        groupData();
        brandData();
        materialData();
        colorData();
        sizeData();

    }, [id]);

    // Separate Effect for Setting Form Data
    useEffect(() => {
        if (id && editFormData) {
            if (Object.keys(editFormData).length > 0 && !isFormUpdated) {

                // Set form values
                setValue("pcode", editFormData.productCode || "");
                setValue("pname", editFormData.productName || "");
                setValue("sku", editFormData.SKU || "");
                setValue("shortdesc", editFormData.short_description || "");
                setValue("desc", editFormData.long_description || "");
                setValue("category", editFormData.category_id || "");
                setValue("group", editFormData.group_id || "");
                setValue("brand", editFormData.brand_id || "");
                setValue("material", editFormData.material_id || "");
                setValue("purchase_rate", editFormData.purchase_rate || "");
                setValue("mrp", editFormData.mrp || "");
                setValue("sales_rate", editFormData.sales_rate || "");
                setValue("delivery_days", editFormData.delivery_days || "");
                setValue("low_stock_remainder", editFormData.low_stock_remainder || "");

                // Update feature1 & feature2 values properly
                const feature1Content = editFormData.featuresDetails1 || "";
                const feature2Content = editFormData.featuresDetails2 || "";

                setContent(feature1Content);
                setContent2(feature2Content);

                setValue("feature1", feature1Content);
                setValue("feature2", feature2Content);

                // Load Existing Images into Dropzone
                let formattedImages = [];

                if (editFormData.images) {
                    try {
                        const imageArray = Array.isArray(editFormData.images)
                            ? editFormData.images
                            : JSON.parse(editFormData.images);

                        formattedImages = imageArray.map((img, index) => ({
                            id: `existing-${index}`,
                            preview2Url: `${SITE_URL}/images/product/${img}`,
                            file: null,
                            isExisting: true,
                        }));

                        setImages(formattedImages);
                        setValue("images", formattedImages);
                    } catch (error) {
                        console.error("Error parsing images:", error);
                    }
                } else {
                    setImages([]); // Ensure it's always an array
                    setValue("images", []);
                }



                // Handle Features
                if (editFormData.generalFeatures) {
                    try {
                        const parsedFeatures = JSON.parse(editFormData.generalFeatures);
                        const formattedFeatures = parsedFeatures.map((item, index) => ({
                            tid: index + 1, // Unique ID for tracking
                            fname: item.fname,
                            file: null, // No actual file for existing features
                            previewUrl: `${SITE_URL}/images/features/${item.file}`, // Construct image path
                        }));

                        setAllfeature(formattedFeatures); // Update state
                    } catch (error) {
                        console.error("Error parsing generalFeatures:", error);
                    }
                }
                setIsFormUpdated(true);
            }

            // Update selected colors & sizes if available
            if (editFormData?.color_id) {
                const selectedColorIds = editFormData.color_id.split(",").map(id => id.trim());
                setSelectedColors(selectedColorIds);
                console.log(selectedColorIds, 'selectedColorIds');

                setValue("color", selectedColorIds.join(",")); // Ensure it's stored as comma-separated
            } else {
                setSelectedColors([]);
                setValue("color", "");
            }

            if (editFormData?.size_id) {
                const selectedSizeIds = editFormData.size_id.split(",").map(id => id.trim());
                setSelectedSizes(selectedSizeIds);
                setValue("size", selectedSizeIds.join(",")); // Ensure it's stored as comma-separated
            } else {
                setSelectedSizes([]);
                setValue("size", "");
            }
        } else {
            // Insertion: Reset form fields
            reset(); // Clears all fields
            setSelectedColors([]);
            setSelectedSizes([]);
            // setImages([]);
            setAllfeature([]);
            setContent('');
            setContent2('');
            setEditMode(false);
        }
    }, [id, editFormData, reset, setValue]);

    const editData = () => {
        setLoadingEditData(true);
        axiosConfig.get(`edit-product/${id}`, setHeader()).then((res) => {
            if (!res.data.error) {
                setEditFormData(res.data.data);
                setEditMode(true);
            }
        }).catch((error) => {
            console.log(error);
            SweetAlert.fire({ title: "Error!", text: "Failed to load product data!", icon: "error" });
        }).finally(() => {
            setLoadingEditData(false);
        });
    }



    // console.log('features: ',features);
    const handleCheckboxChange = (event, stateSetter, fieldName) => {
        const { value, checked } = event.target;
        stateSetter(prevState => {
            const updatedState = checked
                ? [...prevState, value]
                : prevState.filter(item => item !== value);

            // Update react-hook-form state
            // console.log(`${fieldName} updated:`, updatedState);
            setValue(fieldName, updatedState.join(',')); // Update as a comma-separated string
            return updatedState;
        });
    };


    // Remove Image (both new & existing)
    const handleRemoveImage = (index) => {
        setImages((prevImages) => {
            const updatedImages = prevImages.filter((_, i) => i !== index);
            setValue("images", updatedImages);
            return updatedImages;
        });
    };

    const handleImageChange = (event, index) => {
        const files = Array.from(event.target.files); // Support multiple files

        if (files.length > 0) {
            const file = files[0]; // Handle only the first file for this index
            const maxSize = 300 * 1024; // 300KB

            if (file.size > maxSize) {
                alert("File size must be 300KB or less.");
                return;
            }

            const img = new Image();
            img.onload = () => {
                if (img.width !== 1000 || img.height !== 1000) {
                    alert("Image size must be exactly 1000px × 1000px.");
                    return;
                }

                setImages((prevImages) => {
                    const updatedImages = [...prevImages];

                    updatedImages[index] = {
                        file,
                        preview2Url: URL.createObjectURL(file),
                        isExisting: false,
                    };

                    setValue("images", updatedImages); // For react-hook-form
                    return updatedImages;
                });
            };

            img.src = URL.createObjectURL(file);
        }
    };

    const handleAddImageRow = () => {
        setImages((prevImages) => {
            const updatedImages = [...prevImages, { file: null, preview2Url: "", isExisting: false }];
            setValue("images", updatedImages);
            return updatedImages;
        });
    };

    const addRow = () => {
        if (fname !== '' && featurefile !== null) {
            const previewUrl = URL.createObjectURL(featurefile);
            const newFeature = {
                fname,
                featurefile,
                previewUrl,
                tid: Date.now(),
            };

            const updatedFeatures = [...features, newFeature];
            setAllfeature(updatedFeatures);
            setValue("features", updatedFeatures);
            // setAllfeature([...features, { fname, featurefile, previewUrl, tid: Date.now() }])
            setFname("");
            setFeaturefile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = "";
            }
            // console.log(features);
        } else {
            SweetAlert.fire({ title: "Oops!", text: "Please Fill Feature Details!", icon: "warning" });
        }
    }

    const DeleteRow = (tid) => {
        const updatedFeatures = features.filter(fitems => fitems.tid !== tid);
        setAllfeature(updatedFeatures);
        setValue("features", updatedFeatures);
    }

    const FeatureData = (evt) => {
        const newContent = evt.editor.getData();
        setContent(newContent);
        setValue('feature1', newContent);
    }

    const Feature2Data = (evt) => {
        const newContent2 = evt.editor.getData();
        setContent2(newContent2);
        setValue('feature2', newContent2);
    }

    const onSubmit = data => {
        if (data !== '') {
            let imagesData = getValues("images") || [];

            if (!Array.isArray(imagesData)) {
                imagesData = [];
            }

            const formData = new FormData();
            Object.keys(data).forEach((key) => {
                if (key !== "images" && key !== "features") {
                    formData.append(key, data[key]);
                }
            });

            // Append images correctly
            imagesData.forEach((img) => {
                if (img.isExisting) {
                    formData.append("existing_images[]", img.preview2Url.replace(`${SITE_URL}/images/product/`, ""));
                } else if (img.file) {
                    formData.append("images[]", img.file);
                }
            });

            // Handle features files
            if (data.features) {
                data.features.forEach((feature, index) => {
                    formData.append(`features[${index}][fname]`, feature.fname);
                    if (feature.featurefile) {
                        formData.append(`features_file_${index}`, feature.featurefile);
                    }
                });
            }

            if (id) {
                // UPDATE PRODUCT
                setLoadingUpdateProduct(true);
                formData.append("id", id);
                axiosConfig.post("update-product", formData, setHeader()).then((res) => {
                    if (!res.data.error) {
                        SweetAlert.fire({ title: "Success", text: "Updated Successfully", icon: "success" });
                        setEditMode(false);
                        navigate(`${process.env.PUBLIC_URL}/pages/product-list`);
                    } else {
                        SweetAlert.fire({ title: "Oops!", text: "Failed to Update. Try again!", icon: "error" });
                    }
                }).catch((error) => {
                    console.log(error);
                    SweetAlert.fire({ title: "Error!", text: "Network error occurred!", icon: "error" });
                }).finally(() => {
                    setLoadingUpdateProduct(false);
                });
            } else {
                // ADD NEW PRODUCT
                setLoadingAddProduct(true);
                axiosConfig.post("insert-product", formData, setHeader()).then((res) => {
                    if (!res.data.error) {
                        SweetAlert.fire({ title: "Success", text: "Inserted Successfully", icon: "success" });
                        // Reset the form fields
                        reset();
                        setImages([]);
                        setAllfeature([]);
                        setContent('');
                        setContent2('');
                        navigate(`/pages/product-list`);
                    } else {
                        SweetAlert.fire({ title: "Oops!", text: "Failed to insert. Try again!", icon: "error" });
                    }
                }).catch((error) => {
                    console.log(error);
                    SweetAlert.fire({ title: "Error!", text: "Network error occurred!", icon: "error" });
                }).finally(() => {
                    setLoadingAddProduct(false);
                });
            }
        } else {
            errors.showMessages();
        }
    };
    const LoadingSpinner = () => (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
            <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <span className="ml-3">Loading product data...</span>
        </div>
    );

    const CategoryData = () => {
        axiosConfig.get("active-category-list", setHeader()).then((res) => {
            setCategory(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    const groupData = () => {
        axiosConfig.get("active-group-list", setHeader()).then((res) => {
            setGroup(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    const brandData = () => {
        axiosConfig.get("active-brand-list", setHeader()).then((res) => {
            setBrand(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    const materialData = () => {
        axiosConfig.get("active-material-list", setHeader()).then((res) => {
            setMaterial(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    const colorData = () => {
        axiosConfig.get("active-color-list", setHeader()).then((res) => {
            setColor(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    const sizeData = () => {
        axiosConfig.get("active-size-list", setHeader()).then((res) => {
            setSize(res.data.data);
        }).catch((error) => {
            console.log(error);
        });
    };

    const checkExistence = async (field, value) => {
        if (value.trim() === "") return;

        try {
            const response = await axiosConfig.post("check-existence", { field, value }, setHeader());
            if (response.data.exists) {
                if (field === "productCode") {
                    setPcodeError("Already exist !");
                } else if (field === "SKU") {
                    setSkuError("Already exist !");
                }
            } else {
                setPcodeError("");
                setSkuError("");
            }
        } catch (error) {
            console.error("Error checking existence:", error);
        }
    };
    if (loadingEditData) {
        return <LoadingSpinner />;
    }
    const isFormInvalid = Object.keys(errors).length > 0 || pcodeError !== "" || skuError !== "";
    // Custom file validation before upload
    const validateFile = (file) => {
        return new Promise((resolve, reject) => {
            const maxSize = 300 * 1024;

            if (file.size > maxSize) {
                SweetAlert.fire({
                    title: "Validation Error",
                    text: `Selected Image is too large. Max size is 300KB.`,
                    icon: "warning",
                });
                return resolve(null); // reject the file
            }

            const img = new Image();
            img.onload = () => {
                if (img.width > 1000 || img.height > 1000) {
                    SweetAlert.fire({
                        title: "Validation Error",
                        text: `"${file.name}" must be at most 1000px wide and 1000px tall.`,
                        icon: "warning",
                    });
                    return resolve(null);
                }


                resolve(file); // pass the valid file
            };
            img.onerror = () => resolve(null); // reject non-image
            img.src = URL.createObjectURL(file);
        });
    };

    // Handle multiple file validations
    const customGetFilesFromEvent = async (e) => {
        const dt = e.dataTransfer || e.target;
        const files = Array.from(dt.files);

        const validFiles = await Promise.all(files.map(validateFile));
        return validFiles.filter(Boolean); // remove nulls
    };
    return (
        <Fragment>
            <Breadcrumb title="Products" parent="Product" />
            <Wrapper className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <form className="needs-validation" method="POST" encType="multipart/form-data" noValidate="" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="form-row">
                                        <div className="col-md-2 mb-3">
                                            <label htmlFor="validationCustom01">Product Code <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input className="form-control"
                                                name="pcode" type="text" placeholder="Product Code"
                                                {...register('pcode', { required: "Product Code is required" })}
                                                onKeyUp={(e) => checkExistence("productCode", e.target.value)} />
                                            <span>{errors.pcode?.message || pcodeError}</span>

                                        </div>
                                        <div className="col-md-2 mb-3">
                                            <label htmlFor="validationCustom01">SKU <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input className="form-control"
                                                name="sku" type="text" placeholder="SKU"
                                                {...register('sku', { required: "SKU is required" })}
                                                onKeyUp={(e) => checkExistence("SKU", e.target.value)} />
                                            <span>{errors.sku?.message || skuError}</span>
                                        </div>
                                        <div className="col-md-8 mb-3">
                                            <label htmlFor="validationCustom01">Product Name <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input className="form-control" name="pname" type="text" placeholder="Product Name" {...register('pname', { required: "Product Name is required" })} />
                                            <span>{errors.pname?.message}</span>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="col-md-6 mb-3">
                                            <label>Short Description</label>
                                            <textarea className="form-control" rows="3" cols="5" name="shortdesc" {...register('shortdesc', { required: false })} placeholder="Short Description..."></textarea>
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label>Description</label>
                                            <textarea className="form-control" rows="3" cols="5" name="desc" {...register('desc', { required: false })} placeholder="Description..."></textarea>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="col-md-3 mb-3 form-group">
                                            <label>Category <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <Controller
                                                name="category"
                                                control={control}
                                                defaultValue="0" // Default value as 0 (N/A)
                                                rules={{ required: "Category is required" }}
                                                render={({ field }) => (
                                                    <Select
                                                        {...field}
                                                        className="basic-single"
                                                        classNamePrefix="Select Category"
                                                        options={[
                                                            { label: "N/A", value: "0" }, // Add static N/A option
                                                            ...categories,                 // Append your dynamic categories
                                                        ]}
                                                        isDisabled={false}
                                                        isLoading={false}
                                                        isClearable={true}
                                                        isRtl={false}
                                                        isSearchable={true}
                                                        onChange={(selectedOption) =>
                                                            field.onChange(selectedOption ? selectedOption.value : "0") // Default to 0 if cleared
                                                        }
                                                        value={
                                                            [{ label: "N/A", value: "0" }, ...categories].find(
                                                                (option) => option.value === field.value
                                                            ) || { label: "N/A", value: "0" }
                                                        }
                                                    />
                                                )}
                                            />

                                            <span style={{ color: "#ff5370" }}>{errors.category?.message}</span>
                                        </div>

                                        <div className="col-md-3 mb-3 form-group">
                                            <label>Group <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <Controller
                                                name="group"
                                                control={control}
                                                defaultValue="0" // Default value as 0 (N/A)
                                                rules={{ required: "Group is required" }}
                                                render={({ field }) => {
                                                    // Add static N/A option at the top
                                                    const options = [{ label: "N/A", value: "0" }, ...groups];

                                                    return (
                                                        <Select
                                                            {...field}
                                                            className="basic-single"
                                                            classNamePrefix="Select Group"
                                                            options={options}
                                                            isDisabled={false}
                                                            isLoading={false}
                                                            isClearable={true}
                                                            isRtl={false}
                                                            isSearchable={true}
                                                            onChange={(selectedOption) =>
                                                                field.onChange(selectedOption ? selectedOption.value : "0") // fallback to N/A if cleared
                                                            }
                                                            value={
                                                                options.find((option) => option.value === field.value) || options[0]
                                                            }
                                                        />
                                                    );
                                                }}
                                            />

                                            <span style={{ color: "#ff5370" }}>{errors.group?.message}</span>
                                        </div>

                                        <div className="col-md-3 mb-3 form-group">
                                            <label>Brand <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <Controller
                                                name="brand"
                                                control={control}
                                                defaultValue="0" // Set default value to 0 (N/A)
                                                rules={{ required: "Brand is required" }}
                                                render={({ field }) => {
                                                    // Add static N/A option at the top
                                                    const options = [{ label: "N/A", value: "0" }, ...brands];

                                                    return (
                                                        <Select
                                                            {...field}
                                                            className="basic-single"
                                                            classNamePrefix="Select Brand"
                                                            options={options}
                                                            isDisabled={false}
                                                            isLoading={false}
                                                            isClearable={true}
                                                            isRtl={false}
                                                            isSearchable={true}
                                                            onChange={(selectedOption) =>
                                                                field.onChange(selectedOption ? selectedOption.value : "0") // fallback to 0 if cleared
                                                            }
                                                            value={
                                                                options.find((option) => option.value === field.value) || options[0]
                                                            }
                                                        />
                                                    );
                                                }}
                                            />

                                            <span style={{ color: "#ff5370" }}>{errors.barnd?.message}</span>
                                        </div>

                                        <div className="col-md-3 mb-3 form-group">
                                            <label>Material <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <Controller
                                                name="material"
                                                control={control}
                                                defaultValue="0" // Default value as 0 (N/A)
                                                rules={{ required: "Material is required" }}
                                                render={({ field }) => {
                                                    // Add N/A option at the beginning
                                                    const options = [{ label: "N/A", value: "0" }, ...materials];

                                                    return (
                                                        <Select
                                                            {...field}
                                                            className="basic-single"
                                                            classNamePrefix="Select Material"
                                                            options={options}
                                                            isDisabled={false}
                                                            isLoading={false}
                                                            isClearable={true}
                                                            isRtl={false}
                                                            isSearchable={true}
                                                            onChange={(selectedOption) =>
                                                                field.onChange(selectedOption ? selectedOption.value : "0") // fallback to 0 when cleared
                                                            }
                                                            value={
                                                                options.find((option) => option.value === field.value) || options[0]
                                                            }
                                                        />
                                                    );
                                                }}
                                            />

                                            <span style={{ color: "#ff5370" }}>{errors.material?.message}</span>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="col-md-12 mb-3">
                                            <label>Images</label>
                                            {/* <input className="form-control" name="images[]" multiple  
                                        onChange={handleImageChange} type="file" /> */}

                                            {editMode == true ? (
                                                <table className="table">
                                                    <tbody>
                                                        <tr>
                                                            <div className="td-files">

                                                                {images.map((item, index) => (
                                                                    <td key={index} style={{ textAlign: "center" }}>
                                                                        <div className="td-row">
                                                                            <div>{index + 1}</div>
                                                                            <div>
                                                                                {item.preview2Url && (
                                                                                    <img
                                                                                        src={item.preview2Url}
                                                                                        alt={`Preview ${index + 1}`}
                                                                                        style={{ width: "50px", height: "50px", objectFit: "cover" }}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                            <div>
                                                                                <input
                                                                                    className="form-control"
                                                                                    type="file"
                                                                                    name={`images[${index}][]`}
                                                                                    onChange={(e) => handleImageChange(e, index)}
                                                                                />
                                                                            </div>
                                                                            <div>
                                                                                <button
                                                                                    type="button"
                                                                                    title="Delete"
                                                                                    className="btn btn-xs btn-outline-danger"
                                                                                    onClick={() => handleRemoveImage(index)}
                                                                                >
                                                                                    Delete
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                ))}
                                                                <td>
                                                                    <button
                                                                        type="button"
                                                                        title="Add Image"
                                                                        className="btn btn-xs btn-outline-primary"
                                                                        onClick={handleAddImageRow}
                                                                    >
                                                                        + Add Image
                                                                    </button>
                                                                </td>
                                                            </div>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            ) : (
                                                <Controller
                                                    name="images"
                                                    control={control}
                                                    defaultValue={[]}
                                                    render={({ field }) => (
                                                        <Dropzone
                                                            getFilesFromEvent={customGetFilesFromEvent} // 👈 validate before accept
                                                            onChangeStatus={({ file }, status) => {
                                                                if (status === "done") {
                                                                    const newImages = [
                                                                        ...getValues("images"),
                                                                        {
                                                                            file,
                                                                            preview2Url: URL.createObjectURL(file),
                                                                            isExisting: false,
                                                                        },
                                                                    ];
                                                                    setValue("images", newImages);
                                                                }
                                                            }}
                                                            accept="image/*"
                                                            multiple
                                                            inputContent="Drop images (150×300px, ≤ 300KB) or click to select"
                                                            initialFiles={images.map((img) => img.preview2Url)}
                                                        />
                                                    )}
                                                />


                                            )}
                                        </div>

                                    </div>

                                    <div className="form-row">

                                        <div className="col-md-6 mb-3">
                                            <h5>Color</h5>
                                            <div className="card-body animate-chk">
                                                <div className="row">
                                                    <div className="col">
                                                        {colors.map((color) => (
                                                            <label className="m-checkbox-inline" htmlFor={`color-${color.id}`}>
                                                                <input className="checkbox_animated" id={`color-${color.id}`} type="checkbox" value={color.id}
                                                                    defaultChecked={selectedColors.includes(color.id.toString())}
                                                                    onChange={(e) => handleCheckboxChange(e, setSelectedColors, 'color')} />
                                                                {color.name}
                                                            </label>
                                                        ))}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-md-6 mb-3">
                                            <h5>Size</h5>
                                            <div className="card-body animate-chk">
                                                <div className="row">
                                                    <div className="col">
                                                        {sizes.map((size) => (
                                                            <label className="m-checkbox-inline" htmlFor={`size-${size.id}`}>
                                                                <input className="checkbox_animated" id={`size-${size.id}`} type="checkbox" value={size.id}
                                                                    defaultChecked={selectedSizes.includes(size.id.toString())}
                                                                    onChange={(e) => handleCheckboxChange(e, setSelectedSizes, 'size')} />
                                                                {size.name}
                                                            </label>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <input type="hidden" {...register('color')} />
                                    <input type="hidden" {...register('size')} />
                                    <div className="form-row">
                                        <div className="col-md-12 mb-3">
                                            <h5>Features 1</h5>
                                            <div className="card-body">
                                                <CKEditors
                                                    activeclassName="p10"
                                                    name="feature1"
                                                    {...register('feature1', { required: false })}
                                                    content={content}
                                                    events={{
                                                        "change": FeatureData
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="col-md-12 mb-3">
                                            <h5>Features 2</h5>
                                            <div className="card-body">
                                                <CKEditors
                                                    activeclassName="p10"
                                                    name="feature2"
                                                    {...register('feature2', { required: false })}
                                                    content={content2}
                                                    events={{
                                                        "change": Feature2Data
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-row">
                                        <div className="col-md-2 mb-3">
                                            <label>Delivery Days <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input
                                                className="form-control"
                                                name="delivery_days"
                                                type="number"
                                                placeholder="Delivery Days"
                                                {...register('delivery_days', { required: "Delivery Days is required" })}
                                            />
                                            <span>{errors.delivery_days?.message}</span>
                                        </div>

                                        <div className="col-md-2 mb-3">
                                            <label>Purchase Rate <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input
                                                className="form-control"
                                                name="purchase_rate"
                                                type="number"
                                                placeholder="Purchase Rate"
                                                {...register('purchase_rate', { required: "Purchase Rate is required" })}
                                            />
                                            <span>{errors.purchase_rate?.message}</span>
                                        </div>

                                        <div className="col-md-2 mb-3">
                                            <label>MRP <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input
                                                className="form-control"
                                                name="mrp"
                                                type="number"
                                                placeholder="MRP"
                                                {...register('mrp', { required: "MRP is required" })}
                                            />
                                            <span>{errors.mrp?.message}</span>
                                        </div>

                                        <div className="col-md-2 mb-3">
                                            <label>Sales Rate <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input
                                                className="form-control"
                                                name="sales_rate"
                                                type="number"
                                                placeholder="Sales Rate"
                                                {...register('sales_rate', { required: "Sales Rate is required" })}
                                            />
                                            <span>{errors.sales_rate?.message}</span>
                                        </div>

                                        <div className="col-md-2 mb-3">
                                            <label>Low Stock Remainder <span style={{ color: 'transparent', fontSize: '21px' }}>*</span></label>
                                            <input
                                                className="form-control"
                                                name="low_stock_remainder"
                                                type="number"
                                                placeholder="Low Stock Reminder"
                                                {...register('low_stock_remainder')}
                                            />
                                            <span>{errors.low_stock_remainder?.message}</span>
                                        </div>
                                    </div>

                                    <h5 className="mb-3">Features</h5>
                                    <div className="form-row">
                                        <div className="col-md-3 mb-3">
                                            <input className="form-control" name="fname" value={fname} onChange={(e) => setFname(e.target.value)} type="text" placeholder="Name" />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <input className="form-control" name="featurefile" ref={fileInputRef} onChange={(e) => setFeaturefile(e.target.files[0])} type="file" />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <button className="btn btn-xs btn-primary" type="button" onClick={() => { addRow() }}><Plus /> </button>
                                        </div>
                                    </div>

                                    {features.length != 0 &&
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">{"#"}</th>
                                                        <th scope="col">{"Name"}</th>
                                                        <th scope="col">{"Image"}</th>
                                                        <th scope="col">{"Action"}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {features.map((item, i) => {
                                                        return (
                                                            <tr>
                                                                <th scope="row">{++i}</th>
                                                                <td>{item.fname}</td>
                                                                <td><img
                                                                    src={item.previewUrl}
                                                                    alt={item.fname}
                                                                    style={{ width: "40px", height: "30px", objectFit: "cover" }}
                                                                /></td>
                                                                <td className="delete-btn" onClick={(e) => { DeleteRow(item.tid) }}><span><Trash /></span></td>
                                                            </tr>
                                                        );
                                                    })}

                                                </tbody>
                                            </table>
                                        </div>
                                    }

                                    <button
                                        className="btn btn-primary"
                                        type="submit"
                                        disabled={isFormInvalid || loadingAddProduct || loadingUpdateProduct}
                                    >
                                        {loadingAddProduct ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                Adding Product...
                                            </>
                                        ) : loadingUpdateProduct ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
                                                Updating Product...
                                            </>
                                        ) : (
                                            <>{editMode ? 'Update Product' : 'Add Product'}</>
                                        )}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </Wrapper>

        </Fragment>
    );
};

export default Products;


const Wrapper = styled.div`
    .delete-btn{
        cursor: pointer;
    }
    .td-files{
        display: flex;
        flex-wrap: wrap;
    }
     /* Loading states */
    .spinner-border-sm {
        width: 1rem;
        height: 1rem;
    }
    .td-row{
        display: flex;
        flex-direction: row;
        gap: 10px;
        width: 460px;
        justify-content: center;
        align-items: center;
    }
`;
